import { usePaymentMethodsQuery } from '@/api'

export const usePaymentMethods = () => {
  const { data, ...rest } = usePaymentMethodsQuery()
  const user = data?.me
  const defaultPaymentMethodId = user?.defaultPaymentMethodId
  const paymentMethods = user?.paymentMethods ?? []
  return { defaultPaymentMethodId, paymentMethods, ...rest }
}
